import { Http } from '../../../support';

const initialState = {
  busy: false,
  data: {},
  error: undefined,
};

const info = async (store, uuid) => {
  store.setState((state) => {
    state.app.retenciones.info.busy = true;
  });

  try {
    const response = await Http.get(`api/retenciones/${uuid}`);

    store.setState((state) => {
      state.app.retenciones.info.busy = false;
      state.app.retenciones.info.data = response.data;
    });
  } catch (error) {
    store.setState((state) => {
      state.app.retenciones.info.busy = false;
      state.app.retenciones.info.error = error.data || error;
    });
  }
};

const resetError = (store) => (state) => {
  state.app.retenciones.info.error = undefined;
};

const resetResult = (store) => (state) => {
  state.app.retenciones.info.busy = false;
  state.app.retenciones.info.result = undefined;
};

const reset = (store) => (state) => {
  state.app.retenciones.info = {
    ...initialState,
  };
};

const actions = {
  info,
  reset,
  resetError,
  resetResult,
};

const RetencionesInfoStore = {
  state: () => initialState,
  actions,
};

export default RetencionesInfoStore;
